import * as React from 'react';
import style from './MenuDivider.module.scss';

const MenuDivider = () => {
  return <hr className={style.divider} />;
};

export default MenuDivider;
